"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ellipticalPath = exports.getEndpointParameters = void 0;
var react_1 = __importDefault(require("react"));
var Orbit = function (props) {
    var phi = rad(-45);
    var children = props.children, x = props.x, y = props.y, rx = props.rx, ry = props.ry, start = props.start, height = props.height, width = props.width, parentHeight = props.parentHeight, parentWidth = props.parentWidth, _a = props.revolution, revolution = _a === void 0 ? 1000 : _a, animate = props.animate;
    var name = 'ellipseFor' + x + y;
    var x3 = -(parentWidth / 2);
    var y3 = parentHeight / 2;
    var _b = getDisplacementForPoint(x3, y3, rx, ry, phi, Math.PI), cx = _b[0], cy = _b[1];
    var childrenWithSize = react_1.default.Children.map(children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                width: width,
                height: height,
            });
        }
        return child;
    });
    if (animate) {
        return (react_1.default.createElement("g", null,
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", { transform: "translate(-" + width / 2 + ", -" + height / 2 + ")" }, childrenWithSize),
                react_1.default.createElement("animateMotion", { dur: revolution + "s", repeatCount: "indefinite" },
                    react_1.default.createElement("mpath", { href: "#" + name }))),
            react_1.default.createElement("path", { id: name, d: ellipticalPath({
                    cx: cx,
                    cy: cy,
                    rx: rx,
                    ry: ry,
                    phi: phi,
                }, start, 6.28318), fill: "none", stroke: "none" })));
    }
    return (react_1.default.createElement("g", { transform: "translate(" + x + ", " + y + ")" },
        react_1.default.createElement("g", { transform: "translate(-" + width / 2 + ", -" + height / 2 + ")" }, childrenWithSize)));
};
exports.default = Orbit;
function deg(rad) {
    return rad * (180 / Math.PI);
}
function rad(deg) {
    return (deg * Math.PI) / 180;
}
function getEndpointParameters(cx, cy, rx, ry, phi, theta, dTheta) {
    var _a = getEllipsePointForAngle(cx, cy, rx, ry, phi, theta), x1 = _a[0], y1 = _a[1];
    var _b = getEllipsePointForAngle(cx, cy, rx, ry, phi, theta + dTheta), x2 = _b[0], y2 = _b[1];
    var fa = Math.abs(dTheta) > Math.PI ? 1 : 0;
    var fs = dTheta > 0 ? 1 : 0;
    return { x1: x1, y1: y1, x2: x2, y2: y2, fa: fa, fs: fs };
}
exports.getEndpointParameters = getEndpointParameters;
function getEllipsePointForAngle(cx, cy, rx, ry, phi, theta) {
    var abs = Math.abs, sin = Math.sin, cos = Math.cos;
    var M = abs(rx) * cos(theta), N = abs(ry) * sin(theta);
    return [cx + cos(phi) * M - sin(phi) * N, cy + sin(phi) * M + cos(phi) * N];
}
function getDisplacementForPoint(x, y, rx, ry, phi, theta) {
    var abs = Math.abs, sin = Math.sin, cos = Math.cos;
    var M = abs(rx) * cos(theta), N = abs(ry) * sin(theta);
    return [
        x - (cos(phi) * M - sin(phi) * N),
        y - (sin(phi) * M + cos(phi) * N),
    ];
}
function ellipticalPath(ellipse, start, delta) {
    var _a = getEndpointParameters(ellipse.cx, ellipse.cy, ellipse.rx, ellipse.ry, ellipse.phi, start, delta), x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2, fa = _a.fa, fs = _a.fs;
    return "M " + x1 + " " + y1 + "\n            A " + ellipse.rx + " " + ellipse.ry + " " + deg(ellipse.phi) + " " + fa + " " + fs + " " + x2 + " " + y2 + "\n            Z";
}
exports.ellipticalPath = ellipticalPath;
